import React, { useEffect, useState } from "react";
import "./customLiveReports.scss";
import userGroup from "./assets/hugeicons_user-group.svg";
import sealCheck from "./assets/ph_seal-check-light.svg";
import walletSign from "./assets/walletsign.svg";
import cancel from "./assets/cancel-01.svg";
import chartUp from "./assets/chart-up.svg";
import bitcoinBag from "./assets/bitcoin-bag.svg";
import bitcoinBag1 from "./assets/bitcoin-bag1.svg";
import bitcoinBag3 from "./assets/bitcoin-bag3.svg";
import Loader from "../../../../presentationals/Loader/Loader.component";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import FunnelOverview from "./FunnelOverview";
import {
  getLiveReportDailyTrendByDate,
  getLiveReportFunnelDataByDate,
  getLiveReportStatsByDate,
  getMArketingPerformanceStatsByDate,
} from "../ActionCreator";
import moment from "moment";

const statsConfig = [
  {
    key: "totalLeads",
    title: "Total Leads",
    img: userGroup,
    background: "#3EC9FB21",
  },
  {
    key: "totalApprovedLeads",
    title: "Approved Leads",
    img: sealCheck,
    background: "#8A38F529",
  },
  {
    key: "totalDisbursedLeads",
    title: "Disbursed Leads",
    img: walletSign,
    background: "#4FA5642B",
  },
  {
    key: "totalRejectedLeads",
    title: "Rejected Leads",
    img: cancel,
    background: "#E84E4E2B",
  },
  {
    key: "applicationApprovalRate",
    title: "Conversion Rate",
    img: chartUp,
    background: "#F49F2824",
  },
  {
    key: "cpl",
    title: "Cost per Lead",
    img: bitcoinBag,
    background: "#3053D32B",
    format: (v) => `₹${v}`,
  },
  {
    key: "totalRevenue",
    title: "Revenue",
    img: bitcoinBag1,
    background: "#F4CB2833",
  },
  {
    key: "rateOnInvestment",
    title: "Net Margin",
    img: bitcoinBag3,
    background: "#D330C824",
  },
];

const Linedata = [
  {
    name: "Feb 11",
    uv: 4000,
    pv: 2400,
  },
  {
    name: "Feb 12",
    uv: 3000,
    pv: 1398,
  },
  {
    name: "Feb 13",
    uv: 4000,
    pv: 2400,
  },
  {
    name: "Feb 14",
    uv: 3000,
    pv: 1398,
  },
  {
    name: "Feb 15",
    uv: 4000,
    pv: 2400,
  },
  {
    name: "Feb 16",
    uv: 3000,
    pv: 1398,
  },
];

export default function Overview({ appliedDate }) {
  const [statsData, setStatsData] = useState([]);
  const [funnelData, setFunnelData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [dailyTrendsData, setDailyTrendsData] = useState([
    // {
    //   totalLeads: 89,
    //   disbursedLeads: 26,
    //   monthName: "01 Jan",
    //   approvedLeads: 26,
    // },
    // {
    //   totalLeads: 116,
    //   disbursedLeads: 42,
    //   monthName: "02 Jan",
    //   approvedLeads: 42,
    // },
    // {
    //   totalLeads: 127,
    //   disbursedLeads: 25,
    //   monthName: "03 Jan",
    //   approvedLeads: 25,
    // },
    // {
    //   totalLeads: 130,
    //   disbursedLeads: 29,
    //   monthName: "04 Jan",
    //   approvedLeads: 29,
    // },
    // {
    //   totalLeads: 148,
    //   disbursedLeads: 31,
    //   monthName: "05 Jan",
    //   approvedLeads: 31,
    // },
    // {
    //   totalLeads: 137,
    //   disbursedLeads: 24,
    //   monthName: "06 Jan",
    //   approvedLeads: 24,
    // },
    // {
    //   totalLeads: 114,
    //   disbursedLeads: 11,
    //   monthName: "07 Jan",
    //   approvedLeads: 11,
    // },
    // {
    //   totalLeads: 129,
    //   disbursedLeads: 38,
    //   monthName: "08 Jan",
    //   approvedLeads: 38,
    // },
    // {
    //   totalLeads: 128,
    //   disbursedLeads: 21,
    //   monthName: "09 Jan",
    //   approvedLeads: 21,
    // },
    // {
    //   totalLeads: 117,
    //   disbursedLeads: 24,
    //   monthName: "10 Jan",
    //   approvedLeads: 24,
    // },
  ]);

  const getStatsData = (date) => {
    const sDate = moment(date?.from).format("DD-MM-YYYY");
    const eDate = moment(date?.to).format("DD-MM-YYYY");
    setIsLoading(true);
    getMArketingPerformanceStatsByDate(sDate, eDate, (res) => {
      setIsLoading(false);
      const apiData = res?.data[0];

      const mappedData = statsConfig.map((item, index) => {
        const rawValue = apiData?.[item.key] ?? 0;

        return {
          key: item.key,
          title: item.title,
          value: rawValue,
          change: "+0%",
          changeType: "positive",
          img: item.img,
          background: item.background,
        };
      });

      setStatsData(mappedData);
    });
  };

  const getFunnelData = (date) => {
    const sDate = moment(date?.from).format("DD-MM-YYYY");
    const eDate = moment(date?.to).format("DD-MM-YYYY");
    setIsLoading(true);
    getLiveReportFunnelDataByDate(sDate, eDate, (res) => {
      setIsLoading(false);
      setFunnelData(res?.data);
    });
  };

  const getDailyTrendData = (date) => {
    const sDate = moment(date?.from).format("DD-MM-YYYY");
    const eDate = moment(date?.to).format("DD-MM-YYYY");
    setIsLoading(true);
    getLiveReportDailyTrendByDate(sDate, eDate, 'daily', (res) => {
      setIsLoading(false);
      setDailyTrendsData(res?.data)
    });
  };

  useEffect(() => {
    getStatsData(appliedDate);
    getFunnelData(appliedDate);
    getDailyTrendData(appliedDate);
  }, [appliedDate]);
  return (
    <>
      <div className="liveReports-section">
        {isLoading && <Loader />}
        <div className="row">
          {statsData &&
            statsData?.map((val, id) => {
              return (
                <div className="col-sm-3 col-xs-12" key={val.key} style={{marginBottom:'30px'}}>
                  <div className="custom-card-overview">
                    <div className="content-items">
                      <h3 className="titless">{val?.title}</h3>
                      <p className="valss">{val?.value}</p>
                      {/* <div
                        className="statVal"
                        style={{
                          color:
                            val?.changeType === "positive"
                              ? "#10B981"
                              : "#EF4444",
                        }}
                      >
                        <span>{val.changeType === "positive" ? "↑" : "↓"}</span>
                        <span>{val.change}</span>
                        <span style={{ color: "#999" }}>
                          vs Previous Period
                        </span>
                      </div> */}
                    </div>
                    <div
                      className="custom-img"
                      style={{ background: val?.background }}
                    >
                      <img src={val?.img} />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        <div
          className="row"
          style={{
            
          }}
        >
          <div className="col-sm-6 col-xs-12">
            <div className="custom-graph-card-1">
              <FunnelOverview data={funnelData} />
            </div>
          </div>
          <div className="col-sm-6 col-xs-12">
            <div className="custom-graph-card-1" style={{ padding: "20px" }}>
              <h3 className="common-heading">Daily Trend</h3>
              <div className="custom-legend" style={{ justifyContent: "end" }}>
                <div className="legend-box">
                  <div
                    className="small-circle"
                    style={{ background: "#E84E4E" }}
                  ></div>
                  <h5>Leads</h5>
                </div>
                <div className="legend-box">
                  <div
                    className="small-circle"
                    style={{ background: "#74529D" }}
                  ></div>
                  <h5>Disbursement</h5>
                </div>
              </div>
              <div style={{ height: "262px" }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart
                    data={dailyTrendsData}
                    margin={{
                      top: 20,
                      right: 0,
                      left: 0,
                      bottom: 0,
                    }}
                  >
                    <CartesianGrid vertical={false} />
                    <XAxis
                      dataKey="monthName"
                      tickLine={false}
                      axisLine={{ stroke: "#999" }}
                      tick={{ fontSize: 11, fill: "#666" }}
                    />
                    <YAxis
                      tickLine={false}
                      axisLine={{ stroke: "#999" }}
                      tick={{ fontSize: 11, fill: "#666" }}
                    />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="totalLeads"
                      stroke="#FF7070"
                    />
                    <Line
                      type="monotone"
                      dataKey="disbursedLeads"
                      stroke="#74529D"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
